import { Injector } from "@angular/core";
import { BaseNode } from "../BaseNode";
import { MedicinalProductsQueryNode } from "./MedicinalProductsQueryNode";

export class MedicinalProductListQueryNode extends BaseNode{
    override children: MedicinalProductsQueryNode[] = [];
    constructor(injector: Injector, labelTemplate: string) { 
        super(injector, [], labelTemplate);
    }
}